module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.46071d0.woff2";